import { render, staticRenderFns } from "./OrdersTableAdmin.vue?vue&type=template&id=27f09f5a"
import script from "./OrdersTableAdmin.vue?vue&type=script&lang=js"
export * from "./OrdersTableAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports